
(function(){
  function money(cents){
    return 'R' + (Math.round(Number(cents || 0)) / 100)
      .toLocaleString('en-ZA', {minimumFractionDigits:2, maximumFractionDigits:2})
      .replace(/\s/g,'');
  }
  function num(v, fallback){
    var n = parseFloat(String(v || '').replace(/[^0-9.]/g,''));
    return isFinite(n) && n > 0 ? n : fallback;
  }
  function roundUp(q, pack){
    q = parseInt(q, 10);
    if(!isFinite(q) || q < pack) q = pack;
    return Math.ceil(q / pack) * pack;
  }
  function plural(t,n){ return n === 1 ? t : (/s$/i.test(t) ? t : t + 's'); }
  function promoPercent(v){
    var n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.]/g,''));
    if(!isFinite(n)) return 0;
    return Math.max(0, Math.min(100, n));
  }
  function promoTotal(eachPrice, qty, percent){
    return Math.round(Number(eachPrice || 0) * Number(qty || 0) * (100 - Number(percent || 0)) / 100);
  }

  function setupProductForm(form){
    if(form.dataset.stage16Bound) return;
    form.dataset.stage16Bound = '1';

    var panel = form.querySelector('.screwman-stage14-panel');
    if(!panel) return;

    var pack = Math.max(1, num(panel.dataset.pack, 1));
    var packType = panel.dataset.packType || 'Box';
    var eachPrice = num(panel.dataset.eachPrice, 0);
    var discountPercent = promoPercent(panel.dataset.promoPercent);
    var qtyInput = form.querySelector('.screwman-stage14-visible-qty');
    var realQty = form.querySelector('.screwman-stage14-real-qty');
    var minus = form.querySelector('.screwman-stage14-minus');
    var plus = form.querySelector('.screwman-stage14-plus');
    var count = form.querySelector('.screwman-stage14-count');
    var total = form.querySelector('.screwman-stage14-total strong');
    var warning = form.querySelector('.screwman-stage14-warning');

    if(!qtyInput) return;

    function update(force){
      if(force) qtyInput.value = roundUp(qtyInput.value, pack);
      var raw = parseInt(qtyInput.value, 10);
      var qty = isFinite(raw) && raw > 0 ? raw : pack;
      var shown = force ? qty : Math.ceil(qty / pack) * pack;
      if(realQty) realQty.value = shown;
      if(count) count.textContent = pack > 1 ? (shown + ' pieces = ' + (shown / pack) + ' ' + plural(packType, shown / pack)) : 'Sold individually';
      if(total) total.textContent = money(promoTotal(eachPrice, shown, discountPercent));
    }
    function finish(){
      var before = qtyInput.value;
      update(true);
      if(String(before) !== String(qtyInput.value) && warning){
        warning.hidden = false;
        warning.textContent = 'Rounded to full box quantity: ' + qtyInput.value + ' pieces.';
        clearTimeout(warning._t);
        warning._t = setTimeout(function(){ warning.hidden = true; }, 2600);
      }
    }

    update(true);

    var timer;
    qtyInput.addEventListener('input', function(){
      update(false);
      clearTimeout(timer);
      timer = setTimeout(finish, 3500);
    });
    qtyInput.addEventListener('blur', finish);
    qtyInput.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){
        e.preventDefault();
        finish();
        qtyInput.blur();
      }
    });
    if(minus) minus.addEventListener('click', function(){
      qtyInput.value = Math.max(pack, roundUp(qtyInput.value, pack) - pack);
      update(true);
    });
    if(plus) plus.addEventListener('click', function(){
      qtyInput.value = roundUp(qtyInput.value, pack) + pack;
      update(true);
    });
    form.addEventListener('submit', finish, true);
  }

  function setupCard(scope){
    if(scope.dataset.stage16CardBound) return;
    scope.dataset.stage16CardBound = '1';

    var d = scope.querySelector('[data-screwman-pack-data]');
    var pack = Math.max(1, num(d && d.dataset.packageQty, 1));
    var packType = d && d.dataset.packageType ? d.dataset.packageType : 'Box';

    // IMPORTANT: collection card price is EACH price. Total = each price × selected qty.
    var eachPrice = num(d && d.dataset.priceCents, 0);
    var discountPercent = promoPercent(d && d.dataset.promoPercent);

    var input = scope.querySelector('input[name="quantity"], .quantity__input, .screwman-card-qty');
    var totalEl = scope.querySelector('[data-screwman-line-total]');
    var countEl = scope.querySelector('[data-screwman-box-count]');
    if(!input) return;

    function update(force){
      if(force) input.value = roundUp(input.value, pack);
      var raw = parseInt(input.value, 10);
      var qty = isFinite(raw) && raw > 0 ? raw : pack;
      var shown = force ? qty : Math.ceil(qty / pack) * pack;
      if(totalEl) totalEl.innerHTML = '<span>Total</span><strong>' + money(promoTotal(eachPrice, shown, discountPercent)) + '</strong>';
      if(countEl) countEl.textContent = pack > 1 ? (shown + ' pieces = ' + (shown / pack) + ' ' + plural(packType, shown / pack)) : 'Sold individually';
    }

    update(true);

    var timer;
    input.addEventListener('input', function(){
      update(false);
      clearTimeout(timer);
      timer = setTimeout(function(){ update(true); }, 3500);
    });
    input.addEventListener('blur', function(){ update(true); });
    input.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){
        e.preventDefault();
        update(true);
        input.blur();
      }
    });

    scope.addEventListener('click', function(e){
      var btn = e.target.closest('button');
      if(!btn) return;
      var plus = btn.dataset.qtyAction === 'plus' || (btn.textContent || '').trim() === '+';
      var minus = btn.dataset.qtyAction === 'minus' || (btn.textContent || '').trim() === '−' || (btn.textContent || '').trim() === '-';
      if(!plus && !minus) return;
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      input.value = plus ? roundUp(input.value, pack) + pack : Math.max(pack, roundUp(input.value, pack) - pack);
      update(true);
    }, true);
  }

  function hideWrongCardAdds(){
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function(card){
      card.querySelectorAll('button, a.button, .button').forEach(function(btn){
        if(btn.classList.contains('screwman-card-add') || btn.classList.contains('screwman-card-quote')) return;
        var txt = (btn.textContent || '').trim().toLowerCase();
        if(txt === 'add' || txt === 'add to cart' || btn.classList.contains('quick-add__submit')){
          btn.style.display = 'none';
        }
      });
      card.querySelectorAll('.quick-add').forEach(function(el){ el.style.display = 'none'; });
    });
  }

  function setupCartRemoveFallback(){
    if(document.documentElement.dataset.stage16CartRemove) return;
    document.documentElement.dataset.stage16CartRemove = '1';

    document.addEventListener('click', function(e){
      var target = e.target.closest('cart-remove-button a, cart-remove-button button, .cart-remove-button a, .cart-remove-button button, a[href*="/cart/change"], button[name="remove"]');
      if(!target) return;

      var href = target.getAttribute('href') || '';
      var line = null;

      if(target.dataset.index) line = parseInt(target.dataset.index, 10);
      var parent = target.closest('[data-index]');
      if(!line && parent) line = parseInt(parent.dataset.index, 10);

      if(!line && href.indexOf('/cart/change') >= 0){
        try {
          var url = new URL(href, window.location.origin);
          line = parseInt(url.searchParams.get('line'), 10);
        } catch(err) {}
      }

      if(!line || !isFinite(line)) return;

      e.preventDefault();
      e.stopPropagation();

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(function(){ window.location.reload(); })
      .catch(function(){ window.location.href = '/cart'; });
    }, true);
  }

  function clean(){
    document.documentElement.classList.remove('screwman-filters-loading');
    document.querySelectorAll('.screwman-stage11-panel,.screwman-stage12-panel,.screwman-stage13-panel,.screwman-stage10-description,.screwman-stage3-description,.screwman-stage3-specs').forEach(function(el){ el.remove(); });
  }

  function init(){
    clean();
    document.querySelectorAll('.screwman-stage14-product-form').forEach(setupProductForm);
    document.querySelectorAll('.screwman-card-buy-area[data-screwman-pack-scope]').forEach(setupCard);
    hideWrongCardAdds();
    /* Cart quantity and removal are owned by the unified Stage 88 cart controller. */
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('facets:updated', init);
  setInterval(init, 1500);
})();
